import React, { useEffect, useState, useContext } from "react";
import "./Mhero2Hero.css";

import mh2logo from "../../../../assets/images/mhero2/mhero2logo.png";
import mh2car from "../../../../assets/images/mhero2/mhero2.webp";
import heroicon from "../../../../assets/icons/down.png";

import LanguageSelector from "../../../LanguageSelector";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const parseStatPairs = (section) => {
  if (!section) return [];

  const fromLabelValue = Object.keys(section)
    .filter((k) => k.endsWith("_label"))
    .map((labelKey) => {
      const baseKey = labelKey.replace(/_label$/, "");
      return {
        key: baseKey,
        label: section[labelKey],
        value: section[`${baseKey}_value`] ?? "",
      };
    })
    .filter((item) => item.label);

  if (fromLabelValue.length) return fromLabelValue;

  return Object.keys(section)
    .filter((k) => /^stat_\d+$/.test(k))
    .sort((a, b) => Number(a.split("_")[1]) - Number(b.split("_")[1]))
    .map((k) => String(section[k] || "").trim())
    .filter(Boolean)
    .map((text, idx) => {
      const sepIndex = text.indexOf(":");
      if (sepIndex !== -1) {
        return {
          key: `stat_${idx + 1}`,
          label: `${text.slice(0, sepIndex).trim()}:`,
          value: text.slice(sepIndex + 1).trim(),
        };
      }
      return {
        key: `stat_${idx + 1}`,
        label: text,
        value: "",
      };
    });
};

const CLIP_CLASSES_SIX = ["clip-tl", "", "clip-tr", "clip-bl", "", "clip-br"];

const getStatClipClass = (index, total) => {
  if (total !== 6) return "";
  return CLIP_CLASSES_SIX[index] || "";
};

const Mhero2Hero = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getPageContent("mhero2", currentLang);

        // response.sections.hero / stats
        setData(response.sections);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  const { hero, stats } = data;
  const statPairs = parseStatPairs(stats);

  return (
    <div className="mhero2hero">
      {/* LANGUAGE SELECTOR */}
      <div className="absolute top-6 right-6 z-50">
        <LanguageSelector />
      </div>

      {/* LOGO */}
      <div className="mhero2herologo">
        <img className="mh2logo" src={mh2logo} alt="Logo" />
      </div>

      {/* HEADER */}
      <div className="mhero2heroheader">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      {/* CAR IMAGE */}
      <div className="mhero2herocarholder">
        <img
          className="mhero2herocar"
          src={mh2car}
          alt="Mhero2 Car"
        />
      </div>

      {/* STATS */}
      {statPairs.length > 0 && (
        <div className="mhero2herostats" dir="ltr">
          {statPairs.map((item, index) => {
            const clipClass = getStatClipClass(index, statPairs.length);
            return (
              <div
                key={item.key}
                className={`mhero2herostat${clipClass ? ` ${clipClass}` : ""}`}
              >
                <div className="mh2statheader">
                  <p>{item.label}</p>
                </div>
                <div className="mh2statmain">
                  <h1>{item.value}</h1>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* SCROLL ICON */}
      <div className="mhero2heroiconholder">
        <img
          className="mhero2heroicondown"
          src={heroicon}
          alt="Scroll down"
        />
      </div>
    </div>
  );
};

export default Mhero2Hero;
